import image from '../../src/assets/images/user.png'
import photo from '../../src/assets/images/hotel12.jpg'

const options = {  maximumFractionDigits: 2 }


  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(amount);
  };


  const formatNairaCurrency = (amount) => {
    return new Intl.NumberFormat('en-NG', {
      style: 'currency',
      currency: "NGN",
      minimumFractionDigits: 2,
    }).format(amount);
  };


export const applicantsColumns = [
    
    // { field: 'id', title: 'Applicant ID', width: 60 },
    { field: 'userImage', title: 'Photo', width:40, render: rowData => <img src={rowData.userImage ? rowData.userImage : image} style={{width: 50, height:50, borderRadius: '50%'}}/>
     
    },
    { field: 'firstname', title: 'Firstname', width: 80 },
    { field: 'surname', title: 'Lastname', width: 80 },
    { field: 'email', title: 'Email', width: 670 },
    { field: 'phoneNumber', title: 'Telephone', width: 100 },
    { field: 'gender', title: 'Gender', width: 100 },
 
    { field: 'status', title: 'Status', width: 60, render: rowData => 
        <div className={`cellstatus ${rowData.status}`}>{
            rowData.status === "active"? <p style={{color:"#6EC531"}}>active</p>: <p style={{color:"#808080"}}>inactive</p>
            } 
        </div>
      
    },
   
]

export const applicationsColumns = [
    
    // { field: 'visaId', title: 'Visa ID', width: 120 },
    { field: 'firstname', title: 'Firstname', width: 120 },
    { field: 'surname', title: 'Lastname', width: 120 },
    { field: 'country', title: 'Destination', width: 120 },
    { field: 'date', title: 'Application Date', width: 200 },

    { field: 'status', title: 'Status', width: 60, render: rowData => 

        

                    <>
                        {/* {rowData.status === 'PAYMENT' && <div style={{ color:'black', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>PAYMENT</div>}  */}
                        {rowData.status === 'RECEIVED' && <div style={{ color:'green', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>RECEIVED</div>} 
                        {rowData.status === 'PROCESSING' && <div  style={{ color:'orange', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>PROCESSING</div>} 
                        {rowData.status === 'DELIVERING' && <div  style={{color:'blue', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>DELIVERYING</div>} 
                        {rowData.status === 'DELIVERED' && <div style={{color:'black', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>DELIVERED</div>} 
                        {rowData.status === 'APPROVED' && <div style={{ color:'gray', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>APPROVED</div>} 
                        {rowData.status === 'DECLINED' && <div style={{color:'red', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>DECLINED</div>} 
                    </>      

    },
   
]


export const userApplicationsColumns = [
    // { field: 'visaId', headerName: 'Applicantion ID', width: 180 },
    { field: 'firstname', headerName: 'Firstname', width: 180 },
    { field: 'surname', headerName: 'Lastname', width: 180 },
    { field: 'country', headerName: 'Destination', width: 180 },
    { field: 'total', headerName: 'Processing Fee ', width: 120 ,
        renderCell:(params) => {
            return (
                    <>
                        {params.row.currency} {params.row.total}
                    </>
                )
        },
    },    
    { field: 'date', headerName: 'Application Date', width: 180 },
    { field: 'status', headerName: 'Status', width: 120,
        renderCell:(params) => {
            return (
                    <>
                        {params.row.status === 'APPLYING' && <div style={{ color:'red', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>APPLYING</div>} 
                        {params.row.status === 'PAYMENT' && <div style={{ color:'black', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>PAYMENT</div>} 
                        {params.row.status === 'RECEIVED' && <div style={{ color:'green', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>RECEIVED</div>} 
                        {params.row.status === 'PROCESSING' && <div  style={{ color:'orange', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>PROCESSING</div>} 
                        {params.row.status === 'DELIVERING' && <div  style={{color:'blue', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>DELIVERYING</div>} 
                        {params.row.status === 'DELIVERED' && <div style={{color:'black', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}> DELIVERED</div>} 
                        {params.row.status === 'APPROVED' && <div style={{ color:'black', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>COMPLETED </div>} 
                        {params.row.status === 'DECLINED' && <div style={{color:'red', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>DECLINED </div>} 
                    </>
                   )
        },
    },
]

export const chargesColumns = [

    { field: 'premiumServiceCharge', headerName: 'Premium Service Charge', width: 250 },
    { field: 'regularServiceCharge', headerName: 'Regular Service Charge', width: 250 },
    { field: 'visaFee', headerName: 'Visa Processing Fee', width: 250 },
    { field: 'date', headerName: ' Date ', width: 350 },
    // { field: 'timeStamp', title: 'Date', width: 350, render: rowData =>  
        
    //     {

    //         if (rowData.timeStamp) {
    //             const date = rowData.timeStamp.toDate();
    //             return date.toLocaleDateString();
    //         }
    //         return '';

    //     }
        
    //  },
  
]


export const nairachargesColumns = [

    { field: 'premiumServiceCharge', headerName: 'Premium Service Charge', width: 250 },
    { field: 'regularServiceCharge', headerName: 'Regular Service Charge', width: 250 },
    { field: 'visaFee', headerName: 'Visa Processing Fee', width: 250 },
    { field: 'createdAt', headerName: 'Created At', width: 350 },

]


export const dollarchargesColumns = [

    { field: 'premiumServiceCharge', headerName: 'Premium Service Charge', width: 250 },
    { field: 'regularServiceCharge', headerName: 'Regular Service Charge', width: 250 },
    { field: 'visaFee', headerName: 'Visa Processing Fee', width: 250 },
    { field: 'createdAt', headerName: 'Created At', width: 350 },
]


export const applicationHistoryColumns = [
    // { field: 'id', title: 'Visa ID', width: 80 },
  
    { field: 'firstname', title: 'Firstname', width: 140 },
    { field: 'surname', title: 'Lastname', width: 140 },
    { field: 'country', title: 'Destination ', width: 100 },
    // { field: 'timeStamp', title: 'Date', width: 80, render: rowData =>  
        
    //     {

    //         if (rowData.timeStamp) {
    //             const date = rowData.timeStamp.toDate();
    //             return date.toLocaleDateString();
    //         }
    //         return '';

    //     }
        
    // },
   
    { field: 'status', title: 'Status', width: 60, render: rowData => 

        

               <>
                        {rowData.status === 'RECEIVED' && <div style={{ color:'green', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>RECEIVED</div>} 
                        {rowData.status === 'PROCESSING' && <div  style={{ color:'orange', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>PROCESSING</div>} 
                        {rowData.status === 'DELIVERING' && <div  style={{color:'blue', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>DELIVERYING</div>} 
                        {rowData.status === 'DELIVERED' && <div style={{color:'black', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>DELIVERED</div>} 
                        {rowData.status === 'APPROVED' && <div style={{ color:'gray', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>APPROVED</div>} 
                        {rowData.status === 'DECLINED' && <div style={{color:'red', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>DECLINED</div>} 
                    </>      
    },
  
]


export const paymentColumns = [
    // { field: 'id', headerName: 'Visa ID', width: 80 },
  
    { field: 'firstname', title: 'Firstname', width: 140 },
    { field: 'surname', title: 'Lastname', width: 140 },
    { field: 'country', title: 'Destination ', width: 100 },
 
    { field: 'total', title: 'Visa Amount($)', width: 150, render: rowData => formatCurrency(rowData.total)},
    { field: 'status', title: 'Status', width: 60, render: rowData => 

        <>
            {rowData.status === 'RECEIVED' && <div style={{ color:'green', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>RECEIVED</div>} 
            {rowData.status === 'PROCESSING' && <div  style={{ color:'orange', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>PROCESSING</div>} 
            {rowData.status === 'DELIVERING' && <div  style={{color:'blue', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>DELIVERYING</div>} 
            {rowData.status === 'DELIVERED' && <div style={{color:'black', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>DELIVERED</div>} 
            {rowData.status === 'APPROVED' && <div style={{ color:'gray', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>APPROVED</div>} 
            {rowData.status === 'DECLINED' && <div style={{color:'red', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>DECLINED</div>} 
        </>      
    },
]


export const nairapaymentColumns = [
    // { field: 'id', headerName: 'Visa ID', width: 80 },
  
    { field: 'firstname', title: 'Firstname', width: 140 },
    { field: 'surname', title: 'Lastname', width: 140 },
    { field: 'country', title: 'Destination ', width: 100 },
 
    { field: 'total', title: 'Visa Amount(₦)', width: 150, render: rowData => formatNairaCurrency(rowData.total)},
    { field: 'status', title: 'Status', width: 60, render: rowData => 

        <>
            {rowData.status === 'RECEIVED' && <div style={{ color:'green', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>RECEIVED</div>} 
            {rowData.status === 'PROCESSING' && <div  style={{ color:'orange', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>PROCESSING</div>} 
            {rowData.status === 'DELIVERING' && <div  style={{color:'blue', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>DELIVERYING</div>} 
            {rowData.status === 'DELIVERED' && <div style={{color:'black', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>DELIVERED</div>} 
            {rowData.status === 'APPROVED' && <div style={{ color:'gray', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>APPROVED</div>} 
            {rowData.status === 'DECLINED' && <div style={{color:'red', padding:'10px', alignItems:'center', borderRadius:'5px', width:'100%' }}>DECLINED</div>} 
        </>      
    },
]



export const messagesColumns = [

    { field: 'firstname', title: 'Firstname', width: 140 },
    { field: 'surname', title: 'Lastname', width: 140 },
    { field: 'message', title: 'Message', width: 220 },
    { field: 'status', title: 'Status', width: 140 },
    { field: 'timeStamp', title: 'Date', width: 210, render: rowData =>  
        
        {

            if (rowData.timeStamp) {
                const date = rowData.timeStamp.toDate();
                return date.toLocaleDateString();
            }
            return '';

        }
     
    },
   
]


export const announcementColumns = [

    { field: 'Description', headerName: 'Announcement', width: 620 },
    { field: 'createdAt', headerName: 'Date Created', width: 200 },
   
]




export const contactsColumns = [
  
    { field: 'name', title: 'Name', width: 180 },
    { field: 'email', title: 'Email', width: 180 },
    { field: 'telephone', title: 'Telephone', width: 180 },
    { field: 'subject', title: 'Subject', width: 280 },
    { field: 'message', title: 'Message', width: 450 },
 
]


// export const subscriberColumns = [ 
    
//     // { field: 'customerID', title: 'Subscriber ID', width: 60 },
//     { field: 'userImage', title: 'photo', width:60, render: rowData => <img src={rowData.userImage ? rowData.userImage : image} style={{width: 50, height:50, borderRadius: '50%'}}/>},
//     { field: 'firstname', title: 'Firstname', width: 80 },
//     { field: 'lastname', title: 'Lastname', width: 80 },
//     { field: 'email', title: 'Email', width: 60 },
//     { field: 'timeStamp', title: 'Date', width: 80, render: rowData =>  
        
//         {

//             if (rowData.timeStamp) {
//                 const date = rowData.timeStamp.toDate();
//                 return date.toLocaleDateString();
//             }
//             return '';

//         }
        
//      },
//     { field: 'phoneNumber', title: 'Telephone', width: 80 },
//     { field: 'status', title: 'status', width: 80, render: rowData => <div className={`cellstatus ${rowData.status}`}>{rowData.status} </div>
        
//     },
   

// ]


// export const outletsColumns = [
    
//     // { field: 'subscriberID', title: 'OUTLET ID', width: 80 },
//     { field: 'photo', title: 'photo', width:60, render: rowData => <img src={rowData.files[0] ? rowData.files[0] : photo} alt="avatar" style={{width: 50, height:50, borderRadius: '50%'}}/>
     
//     },
//     { field: 'outletname', title: 'Outlet', width: 100 },
//     { field: 'outlet', title: 'Outlet', width: 100 },
//     { field: 'region', title: 'Region', width: 100 },
//     { field: 'area', title: 'Area', width: 100 },
//     { field: 'date', title: 'Date', width: 100 },
//     { field: 'subscriberPlan', title: 'Plan', width: 100 },
//     { field: 'amount', title: 'Amount', width: 100, render: rowData => <div >N{Intl.NumberFormat("en-US",options).format(rowData.amount)} </div>
      
//     },
    
//     { field: 'date', title: 'Payment Date', width: 80 },
//     { field: 'expiration', title: 'Expiration Date', width: 80 },
//     { field: 'agentCode', title: 'Agent Code', width: 60 },
//     { field: 'outlet', title: 'Outlet', width: 60 },
//     { field: 'outletname', title: 'Outlet Name', width: 160 },
//     { field: 'paymentreference', title: 'Payment Reference', width: 100 },
//     { field: 'paymentno', title: 'Payment No.', width: 60 },
    
//     // { field: 'address', title: 'Address', width: 200 },
//     { field: 'userFirstname', title: 'Firstname', width: 60 },
//     { field: 'userLastname', title: 'Lastname', width: 60 },
//     // { field: 'gender', title: 'Gender', width: 60 },
//     { field: 'telephone', title: 'Telephone', width: 60 },
//     { field: 'whatsapp', title: 'whatsApp', width: 60 },
   

// ]



// export const paidColumns = [
    
//     // { field: 'subscriberID', title: 'OUTLET ID', width: 80 },
//     { field: 'photo', title: 'photo', width:60, render: rowData => <img src={rowData.files[0] ? rowData.files[0] : photo} alt="avatar" style={{width: 50, height:50, borderRadius: '50%'}}/>
     
//     },
//     { field: 'outletname', title: 'Outlet', width: 100 },
//     { field: 'outlet', title: 'Outlet', width: 100 },
//     { field: 'region', title: 'Region', width: 100 },
//     { field: 'area', title: 'Area', width: 100 },
//     { field: 'date', title: 'Date', width: 100 },
//     { field: 'subscriberPlan', title: 'Plan', width: 100 },
//     { field: 'amount', title: 'Amount', width: 100, render: rowData => <div >N{Intl.NumberFormat("en-US",options).format(rowData.amount)} </div>
      
//     },
    
//     { field: 'date', title: 'Payment Date', width: 80 },
//     { field: 'expiration', title: 'Expiration Date', width: 80 },
//     { field: 'agentCode', title: 'Agent Code', width: 60 },
//     { field: 'outlet', title: 'Outlet', width: 60 },
//     { field: 'outletname', title: 'Outlet Name', width: 160 },
//     { field: 'paymentreference', title: 'Payment Reference', width: 100 },
//     { field: 'paymentno', title: 'Payment No.', width: 60 },
    
//     { field: 'status', title: 'Status', width: 60 },
//     { field: 'userFirstname', title: 'Firstname', width: 60 },
//     { field: 'userLastname', title: 'Lastname', width: 60 },
//     // { field: 'gender', title: 'Gender', width: 60 },
//     { field: 'telephone', title: 'Telephone', width: 60 },
//     { field: 'whatsapp', title: 'whatsApp', width: 60 },
   

// ]



// export const unpaidColumns = [
    
//     { field: 'subscriberID', title: 'OUTLET ID', width: 80 },
//     { field: 'photo', title: 'photo', width:60, render: rowData => <img src={rowData.files[0] ? rowData.files[0] : photo} alt="avatar" style={{width: 50, height:50, borderRadius: '50%'}}/>
     
//     },
//     { field: 'outletname', title: 'Outlet', width: 100 },
//     { field: 'outlet', title: 'Outlet', width: 100 },
//     { field: 'region', title: 'Region', width: 100 },
//     { field: 'area', title: 'Area', width: 100 },
//     { field: 'date', title: 'Date', width: 100 },
//     { field: 'subscriberPlan', title: 'Plan', width: 100 },
//     { field: 'amount', title: 'Amount', width: 100, render: rowData => <div >N{Intl.NumberFormat("en-US",options).format(rowData.amount)} </div>
      
//     },
    
//     { field: 'date', title: 'Payment Date', width: 80 },
//     { field: 'expiration', title: 'Expiration Date', width: 80 },
//     { field: 'agentCode', title: 'Agent Code', width: 60 },
//     { field: 'outlet', title: 'Outlet', width: 60 },
//     { field: 'outletname', title: 'Outlet Name', width: 160 },
//     { field: 'paymentreference', title: 'Payment Reference', width: 100 },
//     { field: 'paymentno', title: 'Payment No.', width: 60 },
//     { field: 'status', title: 'Status', width: 60 },
//     { field: 'userFirstname', title: 'Firstname', width: 60 },
//     { field: 'userLastname', title: 'Lastname', width: 60 },
//     // { field: 'gender', title: 'Gender', width: 60 },
//     { field: 'telephone', title: 'Telephone', width: 60 },
//     { field: 'whatsapp', title: 'whatsApp', width: 60 },
   

// ]


// export const paymentsColumns = [

//     { field: 'transactionStatus', title: 'Transaction Status', width: 120, render: rowData => <div >{rowData.transactionStatus? "Successfull": ' Declined'}</div>},
//     { field: 'amount', title: 'Amount', width: 50, render: rowData => <div >N{Intl.NumberFormat("en-US",options).format(rowData.amount)} </div>
//     },
//     { field: 'plan', title: 'Plan', width: 60 },
//     { field: 'date', title: 'Payment Date', width: 160 },
//     { field: 'expiration', title: 'Expiration Date', width: 160 },
//     { field: 'agentCode', title: 'Agent Code', width: 60 },
//     { field: 'outlet', title: 'Outlet', width: 120 },
//     { field: 'outletname', title: 'Outlet Name', width: 160 },
//     { field: 'paymentReference', title: 'Payment Reference', width: 100 },
//     { field: 'paymentno', title: 'Payment No.', width: 60 },
//     { field: 'userFirstname', title: 'Firstname', width: 100 },
//     { field: 'userLastname', title: 'Lastname', width: 100 },
//     { field: 'gender', title: 'Gender', width: 60 },
//     { field: 'telephone', title: 'Telephone', width: 60 },
//     { field: 'whatsapp', title: 'whatsApp', width: 60 },
//     { field: 'address', title: 'Address', width: 120 },

// ]


export const messageColumns = [
    { field: 'title', title: 'Title', width: 100 },
    { field: 'body', title: 'Message', width: 500 },
    { field: 'timestamp', title: 'Date Created', width: 100 },
      
]


export const individualColumns = [
    { field: 'title', title: 'Title', width: 100 },
    { field: 'message', title: 'Message', width: 100 },
    { field: 'date', title: 'Date', width: 100 },
      
]

export const groupColumns = [
    { field: 'title', title: 'Title', width: 100 },
    { field: 'body', title: 'Message', width: 100 },
    { field: 'timestamp', title: 'Date', width: 100 },
      
]


export const advertColumns = [
    
    // { field: 'subscriberID', title: 'OUTLET ID', width: 80 },
    { field: 'advertImage', title: 'Photo', width:60, render: rowData => <img src={rowData.advertImage ? rowData.advertImage : photo} alt="avatar" style={{width: 50, height:50, borderRadius: '50%'}}/>
     
    },
    { field: 'title', title: 'Title', width: 100 },
    { field: 'description', title: 'Description', width: 200 },
    { field: 'brandname', title: 'Brand name', width: 100 },
    { field: 'brandaddress', title: 'Brand Address', width: 200 },
    { field: 'brandtelephone', title: 'Brand Telephone', width: 100 },
    { field: 'datePublished', title: 'Date Published', width: 100 },
    { field: 'brandsocials', title: 'Socials', width: 100 },
    { field: 'likeCount', title: 'Likes', width: 30 },
    { field: 'viewCount', title: 'Views', width: 30 },
    { field: 'messageCount', title: 'Messages', width: 30 },
    { field: 'status', title: 'Status', width: 50, render: rowData => <p style={{color: rowData.status === "active" ? "#3a9833ff" : "#ed2020ff"}}>{rowData.status}</p>},

]


export const releasesColumns = [
    // { field: 'icon', title: 'Icon', width: 80, render: rowData => <div > </div>},
    { field: 'title', title: 'Title', width: 100 },
    { field: 'message', title: 'Message', width: 100 },
    // { field: 'plan', title: 'Plan', width: 100 },
    { field: 'date', title: 'Date', width: 100 },
    { field: 'status', title: 'Status', width: 100 },
      
]


export const staffColumns = [
    { field: 'staffID', headerName: 'Staff ID', width: 80 },
    { 
        field: 'photo', headerName: 'Photo', width:80,
        renderCell:(params) => {
            return(
                <div className="cellwithphoto">
                    <img src={params.row.img} alt="avatar" className="cellphoto"/>
                    
                </div>
            )
        }
    },
    { field: 'firstname', headerName: 'Firstname', width: 150 },
    { field: 'lastname', headerName: 'Lastname', width: 150 },
    { field: 'role', headerName: 'Staff Role', width: 180 },
    { field: 'telephone', headerName: 'Phone Number', width: 150 },
    { field: 'date', headerName: 'Reg Date', width: 100 },
    { field: 'email', headerName: 'Email Address', width: 160 },

    { field: 'status', headerName: 'Status', width: 80,
        renderCell:(params) => {
            return <div className={`cellstatus ${params.row.status}`}>{params.row.status} </div>
        },
    },
]

export const agentColumns = [
    { field: 'agentID', headerName: 'Agent Code', width: 130 },
    { 
        field: 'photo', headerName: 'Photo', width:100,
        renderCell:(params) => {
            return(
                <div className="cellwithphoto">
                    <img src={params.row.img} alt="avatar" className="cellphoto"/>
                    
                </div>
            )
        }
    },
    { field: 'firstname', headerName: 'Firstname', width: 150 },
    { field: 'lastname', headerName: 'Lastname', width: 150 },
    { field: 'role', headerName: 'Agent Role', width: 180 },
    { field: 'telephone', headerName: 'Phone Number', width: 150 },
    { field: 'email', headerName: 'Email Address', width: 160 },

    { field: 'status', headerName: 'Status', width: 140,
        renderCell:(params) => {
            return <div className={`cellstatus ${params.row.status}`}>{params.row.status} </div>
        },
    },
]


export const settingsColumns = [
 
    { field: 'firstname', headerName: 'Firstname', width: 180 },
    { field: 'lastname', headerName: 'Lastname', width: 180 },
    { field: 'email', headerName: 'Email ', width: 220 },
    { field: 'telephone', headerName: 'Telephone', width: 180 },
    { field: 'role', headerName: 'Role', width: 160,
        renderCell:(params) => {
            return  params.row.role === "adminAccess" ? "Admin" : "Sub Admin" 
             
        },
    },

    { field: 'status', headerName: 'Status', width: 160,
        renderCell:(params) => {
            return  params.row.status === "active" ? <span style={{color:'green'}}>{params.row.status}</span>  : <span style={{color:'red'}}>{params.row.status}</span>
             
            
            
        },
    },
]

